<template>
    <div>
      <Transfer_goods_detail/>
    </div>
  </template>
  
  <script>
  import Transfer_goods_detail from "@/components/adminArin/pos_system/warehouse/warehouse_all/Transfer_goods_detail";
  export default {
    name: "Transfergoodsdetail",
    components: {
      Transfer_goods_detail
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  